import type { KeyboardEventHandler } from 'react';

type GetKeyboardNavigationReturn = {
	onKeyDown: KeyboardEventHandler<HTMLElement>;
	onKeyUp: KeyboardEventHandler<HTMLElement>;
};

enum KeyCodes {
	ENTER = 'Enter',
	SPACE = 'Space',
}

const useKeyboardNavigation = (onClick: () => void): GetKeyboardNavigationReturn => {
	const onKeyUp: KeyboardEventHandler<HTMLElement> = (event) => {
		if (event.code === KeyCodes.SPACE) {
			onClick();
		}
	};

	const onKeyDown: KeyboardEventHandler<HTMLElement> = (event) => {
		// The action button is activated by space on the keyup event, but the
		// default action for space is already triggered on keydown. It needs to be
		// prevented to stop scrolling the page before activating the button.
		if (event.code === KeyCodes.SPACE) {
			event.preventDefault();
		}

		// If enter is pressed, activate the button
		if (event.code === KeyCodes.ENTER) {
			event.preventDefault();
			onClick();
		}
	};

	return { onKeyDown, onKeyUp };
};

export default useKeyboardNavigation;
